import { useState } from 'react';
import { Button } from '../ui/Button';
import { field } from '../create/Field';
import { inputOfInstant, instantOfInput } from './ticketView';

/**
 * The reply-due, set on the shop's clock (`datetime-local` read in the shop's zone, not the
 * browser's). Save sends the draft; Clear takes the promise away. Keyed by its value by the
 * caller, so a new reply-due from the server is a new draft; nothing is mirrored by an effect.
 */
export function ReplyDueEditor({
  id,
  value,
  tz,
  busy,
  onSave,
}: {
  id: string;
  value: Date | string | null;
  tz: string;
  busy: boolean;
  onSave: (replyDueAt: Date | null) => void;
}) {
  const initial = value ? inputOfInstant(value, tz) : '';
  const [draft, setDraft] = useState(initial);
  const at = instantOfInput(draft, tz);
  const changed = draft !== initial && (draft === '' || at !== null);
  return (
    <span className="flex flex-wrap items-center justify-end gap-2">
      <input
        id={id}
        type="datetime-local"
        className={`${field} sm:w-56`}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
      />
      {changed ? (
        <Button
          size="sm"
          aria-disabled={busy || undefined}
          onClick={() => {
            if (!busy) onSave(draft === '' ? null : at);
          }}
        >
          Save
        </Button>
      ) : value ? (
        <Button
          variant="ghost"
          size="sm"
          aria-disabled={busy || undefined}
          onClick={() => {
            if (!busy) onSave(null);
          }}
        >
          Clear
        </Button>
      ) : null}
    </span>
  );
}
